import classNames, { Value as ClassValue } from "classnames";
import React, { CSSProperties } from "react";
import { isNodeEmpty } from "Tools";

export function Section(props: {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
  className?: ClassValue;
  style?: CSSProperties;
}) {
  return (
    <section className={classNames(props.className)} style={props.style}>
      <header className="title has-text-centered">
        <h1
          className="title is-5 is-spaced"
          style={{
            marginBottom: !isNodeEmpty(props.subtitle) ? "0.2em" : "0.5em",
          }}
        >
          {props.title}
        </h1>
        {!isNodeEmpty(props.subtitle) && (
          <h2 className="subtitle is-6" style={{ marginBottom: "0.5em" }}>
            {props.subtitle}
          </h2>
        )}
      </header>
      {props.children}
    </section>
  );
}

export function Subsection(props: {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
  className?: ClassValue;
  style?: CSSProperties;
}) {
  return (
    <section className={classNames(props.className)} style={props.style}>
      <header
        className="title has-text-centered"
        style={{ marginBottom: "1rem" }}
      >
        <h2 className="has-text-weight-bold subtitle is-6">{props.title}</h2>
      </header>
      {props.children}
    </section>
  );
}
